export const DEFAULT_LOGO_URL = '/logo.png';
export const DEFAULT_FAVICON_URL = '/favicon.ico';

export const getLogoSrc = (siteSettings) => {
  if (siteSettings?.logo_base64) {
    const logo = siteSettings.logo_base64;
    return logo.startsWith('data:') ? logo : `data:image/png;base64,${logo}`;
  }
  return DEFAULT_LOGO_URL;
};

export const getFaviconSrc = (siteSettings) => {
  if (siteSettings?.favicon_base64) {
    const favicon = siteSettings.favicon_base64;
    return favicon.startsWith('data:') ? favicon : `data:image/png;base64,${favicon}`;
  }
  return DEFAULT_FAVICON_URL;
};
